import { makeStyles, shorthands } from '@fluentui/react-components';

export const useCardSelectorStyles = makeStyles({
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    ...shorthands.gap('16px'),
    marginTop: '24px',
    marginBottom: '24px',
  },
  divider: {
    maxHeight: '1px',
  },
});
